<template>
    <div class="module">
        <ModuleTitle  class="page-title" :caption="stories.title | pageTitle" :text="stories.desc"></ModuleTitle>
        <ScrollList class="story" :items="stories.items" :cols="4" @click="goToPage">
            <template v-slot:default="{card}">
                <h4>{{card.name}}</h4>
                <b-card-text class="desc" :title="card.desc">
                    {{card.desc}}
                </b-card-text>
                <a :href="card.parentPath + card.slug" onclick="return false">
                    <b-card-text class="link" @click="goToPage(card.slug)">
                        {{card.link}}
                    </b-card-text>
                </a>
            </template>
        </ScrollList>
    </div>
</template>

<script>
    import ModuleTitle from '../../common/ModuleTitle'
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'detailInfo',
        props: {
            stories: Object,
        },
        components: {
            ModuleTitle,
            ScrollList,
        },
        methods: {
            goToPage(slug) {
                this.$router.push({
                    path: '/stories/' + slug
                })

                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    .en {
        .module /deep/ h4 {
            margin-bottom: 10px !important;
            font-size: 14px !important;
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
            white-space: nowrap;
        }

        .module /deep/ .card-text {
            font-size: 12px !important;
            line-height: 22px !important;

            &.desc {
                height: 90px !important;
                margin-bottom: 10px !important;
            }
        }
    }

    .module /deep/ .list {
        margin-top: 0;
        .list-item {
            flex-wrap: wrap;

            .col {
                &:nth-child(n+4) {
                    margin-top: 30px;
                }
            }
        }
    }

    .module /deep/ h4 {
        margin-top: 20px;
        margin-bottom: 25px;
        font-size: 18px;
        line-height: 30px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
    }

    .module /deep/ .desc {
        height: 80px !important;
        margin-bottom: 30px !important;
        font-size: 14px;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: justify;
    }

    .module /deep/ .link {
        font-size: 14px;
        line-height: 20px;
        text-decoration: underline;
        cursor: pointer;
        transition: font-weight .3s;
    }
</style>
